import type { VinylAmznPlayer } from '@amzn/vinyl-amzn'

type KeySystemProbe = { capabilities: Pick<VinylAmznPlayer['capabilities'], 'supportsKeySystem'> }

let catalogEngine: KeySystemProbe | null = null

export function setWebDrmProbeEngine(engine: KeySystemProbe | null): void {
    catalogEngine = engine
}

/**
 * Whether this browser can decrypt Widevine or FairPlay, asked of Vinyl on each call. Queries each
 * key system directly: `probeSupport().drm` is keyed by enum member names, so lookups by key-system
 * value always miss. `null` before the catalog engine exists.
 */
export async function isWebDrmPlaybackSupported(): Promise<boolean | null> {
    const engine = catalogEngine
    if (!engine) return null
    const { DrmKeySystem } = await import('@amzn/vinyl-amzn')
    return (
        (await engine.capabilities.supportsKeySystem(DrmKeySystem.WIDEVINE)).supported ||
        (await engine.capabilities.supportsKeySystem(DrmKeySystem.FAIR_PLAY_1_0)).supported
    )
}
